import { render } from "./SelfieInstructionEnd.vue?vue&type=template&id=251381c6"
import script from "./SelfieInstructionEnd.vue?vue&type=script&lang=js"
export * from "./SelfieInstructionEnd.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__